import { render } from "./SummarySocialReportsView.vue?vue&type=template&id=1ef6f34a&scoped=true&ts=true"
import script from "./SummarySocialReportsView.vue?vue&type=script&lang=ts"
export * from "./SummarySocialReportsView.vue?vue&type=script&lang=ts"

import "./SummarySocialReportsView.vue?vue&type=style&index=0&id=1ef6f34a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef6f34a"]])

export default __exports__